/**
 * thehope.one presents every Impact Card fund figure in Korean won,
 * regardless of the currency stored on the cause content.
 *
 * Values are formatted, not converted — amounts are expected to already be
 * stored in won. If the API starts returning other currencies, convert before
 * passing the amount in here.
 */
export const IMPACT_CURRENCY = "KRW";

export const IMPACT_CURRENCY_LOCALE = "ko-KR";

export function formatImpactMoney(
  amount?: number,
  locale: string = IMPACT_CURRENCY_LOCALE
): string {
  const safeAmount = typeof amount === "number" && Number.isFinite(amount) ? amount : 0;

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: IMPACT_CURRENCY,
      maximumFractionDigits: 0,
    }).format(safeAmount);
  } catch {
    return `₩${safeAmount.toLocaleString()}`;
  }
}

/** Bare number without the symbol — for preset chips and inputs. */
export function formatImpactAmount(amount: number): string {
  return new Intl.NumberFormat(IMPACT_CURRENCY_LOCALE).format(amount);
}
